module.exports = __webpack_public_path__ + "static/img/image_map@2x.21cde20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/image_map@2x.png
// module id = dKjO
// module chunks = 1